/**
 * Puts the `sukha.client` label on a span, for `beforeSendSpan` (TX-5459).
 *
 * Every Sukha server client tags its events `sukha.client` through
 * `initialScope`, because four deployments share one Sentry project. Sentry 11
 * stopped applying scope tags to spans, so without this the label would be on
 * errors but missing from every trace. `beforeSendSpan` may modify a span but
 * not replace or drop it, so the span is updated in place and returned.
 *
 * Generic over the span shape so this package keeps no Sentry dependency.
 */
export function labelSentrySpan<T extends { attributes?: Record<string, unknown> }>(span: T, client: string): T {
  span.attributes = { ...span.attributes, "sukha.client": client };
  return span;
}
